export const LOG_IN = 'LOG_IN'
export const SIGN_UP = 'SIGN_UP'
export const LOG_OUT = 'LOG_OUT'
export const AUTHENTICATE = 'AUTHENTICATE'
export const DID_TRY_AL = 'DID_TRY_AL'

export const logInAC = (token, userId, email) => ({ type: LOG_IN, token, userId, email })
export const signUpAC = (token, userId, email) => ({ type: SIGN_UP, token, userId, email })
export const logOutAC = () => ({ type: LOG_OUT })
export const authenticateAC = (token, userId, email) => ({
    type: AUTHENTICATE,
    token,
    userId,
    email
})
export const didTryAlAC = () => ({ type: DID_TRY_AL })
